var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isEntregaPage && !_vm.$route.meta.hideHeader)?_c('Header',{staticClass:"sticky-header-wrapper",attrs:{"showSearch":_vm.$route.meta.showSearch}}):_vm._e(),_c('div',{staticClass:"view"},[_c('router-view')],1),(_vm.$route.meta.showFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }